import { Component, inject, ViewChild } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    imports: [DxDataGridModule],
    selector: 'app-part-option-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Sales AddOn Options</h2>
        </div>
        <div class="d-flex" style="align-items: flex-start;">
            <div class="flex-fill d-flex flex-column">
                <div class="card">
                    <div class="card-body">
                        <dx-data-grid
                            #partsGrid
                            [dataSource]="options"
                            keyExpr="id"
                            height="360"
                            [columnAutoWidth]="false"
                            (onToolbarPreparing)="onToolbarPreparing($event)"
                            class="lines-grid"
                            [showBorders]="true"
                            (onInitialized)="onGridInitialized($event)"
                        >
                            <dxi-column dataField="partNumber" caption="Part Number" width="165"></dxi-column>
                            <dxi-column dataField="description" caption="Description" width="365"></dxi-column>
                            <dxi-column dataField="mfgDescription" caption="Manufacturer Description" width="365"></dxi-column>
                            <dxi-column dataField="price" caption="Price" width="120" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                            <dxi-column width="100"></dxi-column>

                            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                            <dxo-export [enabled]="false"></dxo-export>
                            <dxo-selection mode="multiple"></dxo-selection>
                            <dxo-state-storing [enabled]="true" [storageKey]="'part-number-generator-options-grid'"></dxo-state-storing>

                            <div *dxTemplate="let data of 'toolbarButtons'"></div>
                            <div *dxTemplate="let data of 'toolbarText'">
                                <span class="me-3"
                                    ><strong>Matching Parts: {{ matchingParts?.length ?? 0 }} parts</strong></span
                                >
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    styles: `
        .table-min-width {
            min-width: 150px;
        }
    `,
    standalone: true,
})
export class PartOptionDialogComponent {
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);
    uow = inject(GenesisUnitOfWork);
    modalService = inject(BsModalService);

    @ViewChild('partsGrid') partsGrid: any;
    result = new Subject<{ success: boolean; value: any }>();
    options!: any[];

    async ngOnInit() {}

    async getData() {}

    onGridInitialized(e) {
        // Use setTimeout to ensure state has been restored from storage
        setTimeout(() => {
            const currentState = e.component.state();
            if (currentState?.selectedRowKeys?.length > 0) {
                currentState.selectedRowKeys = [];
                e.component.state(currentState);
            }
        });
    }

    onToolbarPreparing(e: any) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            },
        );
    }

    async save() {
        this.result.next({ success: true, value: this.partsGrid.instance.getSelectedRowsData() } as any);
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false, value: null });
    }
}
